<template>
  <div class="design-accept-wrap" ref="containerRef">
    <xl-card
      class="case-card-style"
      shadow="never"
      :body-style="{
				padding: '12px',
				display: 'flex',
				'flex-wrap': 'nowrap',
				'align-items': 'center',
				position: 'relative'
			}"
    >
      <div class="case-top-icon back-icon">
        <xl-icon is-button name="fanhui1" @click="gotoback" size="20" color="var(--oem-color-n8)"></xl-icon>
      </div>
      <!-- <div class="case-top-icon designType"> -->
        <img class="order-img" :src="imageUrl" alt=""/>
      <!-- </div> -->
      <div class="case-top-conts">
        <!-- <div class="case-top-conts-t">{{detailInfo.orderName}}</div> -->
        <div class="case-top-conts-b">
          <div class="order-title">
                <div class="case-text">{{ detailInfo.orderName }}</div>
                <div v-if="detailInfo.orderState === 'waitAccept' || detailInfo.orderState === 'inDesign' || detailInfo.orderState === 'waitDesign'"  class="order-status blue-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
                <div v-if="detailInfo.orderState === 'waitCheck'" class="order-status green-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
                <div v-if="detailInfo.orderState === 'pause' || detailInfo.orderState === 'waitRecover' || detailInfo.orderState === 'waitRedesign'" class="order-status red-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
                <div v-if="detailInfo.orderState === 'cancel' || detailInfo.orderState === 'complete' || detailInfo.orderState ==='OrderStateRedesignComplete'" class="order-status gray-color">{{ $t( `design.order.${detailInfo.orderState}` ) }}</div> 
              </div>
          </div>
          <div class="order-title">
              <div class="info-box">
                <img src="../../assets/image/type_icon.svg" alt="" />
                <span class="info-text"
                  >{{ detailInfo.typeName }}-<span class="text-color">{{ detailInfo.productName }}</span></span>
              </div>
              <div class="info-box">
                <!-- <xl-icon color="#737E99" size="14"><User /></xl-icon> -->
                <img class="user-icon" src="../../assets/image/user_icon.svg" alt=""/>
                <span class="info-text"
                  >{{$t('design.creator') || "创建人"}}-<span class="text-color">{{ detailInfo.createBy }}</span></span>
              </div>
          </div>
      </div>
    </xl-card>
    <xl-card class="design-card-content" shadow="never" :body-style="{ padding: '0' }">
      <div class="content">
        <div class="left accept-three-model">
          <div class="ai-fail-wrap" v-if="aiFail">
            <div><img :src="aiFail === 'failed' ? aiFailSvg : aiTransferSvg" alt=""></div>
            <p>{{ aiFail === 'failed' ? $t('design.orderDetail.aiModelFail') : $t('design.orderDetail.aiModelCreating')}}</p>
          </div>
          <template v-else>
            <three-d-model ref="previewModel" :showAiResult="showAiResult" :showManualResult="showManualResult" :noSort="true"  background="#fff" v-show="!loading"></three-d-model>
          </template>
          <div v-if="detailInfo.aiOrder && detailInfo.orderState === 'complete'" class="is-apply-icon">
            <span v-if="lang === 'zh-cn'">
              <img v-if="detailInfo.aiResultApplyState === 'enable'" src="../../assets/image/applied-zh.png" alt="">
              <img v-else-if="detailInfo.aiResultApplyState === 'disable'" src="../../assets/image/unavailable-zh.png" alt="">
            </span>
            <span v-else>
              <img v-if="detailInfo.aiResultApplyState === 'enable'" src="../../assets/image/applied-en.png" alt="">
              <img v-else-if="detailInfo.aiResultApplyState === 'disable'" src="../../assets/image/unavailable-en.png" alt="">
            </span>
          </div>      
        </div>
        <div class="right" v-if="!(['designerService', 'dentalx'].includes(platform) && route?.query?.type == 'ai') && detailInfo?.aiOrder !== 1 && !loading">
          <title-name>{{$t('design.orderDetail.qualityScreenshot') || '质检截图'}}</title-name>
          <div v-if="srcList?.length" class="image-wrap">
            <div v-for="(item, index) in srcList" :key="item.url" class="item">
              <xl-image :src="item.url" fit="contain" :preview-src-list="srcList" :initial-index="index" />
              <xl-tooltip :content="item.filename" placement="top">
                <div class="title">{{ item.filename }}</div>
              </xl-tooltip>
            </div>
          </div>
          <!-- 暂无数据 -->
          <div v-else class='no-data-box'>
              <noData></noData>
          </div>
        </div>
      </div>
      <div class="footer" v-if="!platform && route?.query?.type !== 'info'">
        <div class="statement"><xl-checkbox v-model="statementCheck"></xl-checkbox>{{$t('design.disclaimer')}}</div>
        <div class="btns">
          <xl-button v-if="detailInfo?.aiOrder" @click="handleUnavailable">{{$t('design.orderDetail.aiModelUnavailable') || "设计不可用"}}</xl-button>
          <xl-button v-else @click="handleDesignAdjustment">{{$t('design.orderDetail.designAdjustment') || "设计调整"}}</xl-button>
          <xl-button type="primary" @click="onSubmit" :loading="payLoading">{{ payLoading ? $t('design.orderDetail.acceptDesignLoading') : $t('design.orderDetail.determineDesign') || '确定设计' }}</xl-button>
        </div>
        <!-- <div class="btns" v-else>
          <xl-button @click="handleUnavailable">{{$t('设计不可用') || "设计不可用"}}</xl-button>
          <xl-button type="primary" @click="handelApplication" :loading="payLoading">{{ payLoading ? $t('design.orderDetail.acceptDesignLoading') : $t('应用结果') || '应用结果' }}</xl-button>
        </div> -->
      </div>
      <div class="footer" v-else-if="platform === 'dentalxDesign' && detailInfo.state === 'waitConfirmDesign'">
        <div class="statement"></div>
        <div class="btns">
          <xl-button @click="handleDesignAdjustmentAdmin">{{$t('design.orderDetail.designAdjustment') || "设计调整"}}</xl-button>
          <xl-button type="primary" @click="onSubmitAdmin" :loading="payLoading">{{ payLoading ? $t('design.orderDetail.acceptDesignLoading') : $t('design.orderDetail.determineDesign') || '确定设计' }}</xl-button>
        </div>
      </div>
      <!-- todo: 状态的判断是否展示 -->
      <div class="footer" v-else-if="platform === 'designerService' && route?.query?.type == 'ai' && !detailInfo.aiResultApplyState && !aiFail && !loading">
        <div class="statement"><xl-checkbox v-model="statementCheck"></xl-checkbox>{{$t('design.disclaimer')}}</div>
        <div class="btns">
          <xl-button @click="onAdjustmentDesigner">{{ $t('design.orderDetail.aiModelUnavailable') }}</xl-button>
          <xl-button type="primary" @click="onSubmit" :loading="payLoading">{{ payLoading ? $t('design.orderDetail.usingAiModel') : $t('design.orderDetail.useAiModel')}}</xl-button>
        </div>
      </div>
    </xl-card>
    <designAdjustment ref="designAdjustmentRef"></designAdjustment>
    <designAdjustmentAdmin ref="designAdjustmentAdminRef"></designAdjustmentAdmin>

    <!-- <dropIn ref="dropInRef" @getDetail="getDetail" @changePayLoading="changePayLoading"></dropIn> -->

    <payment ref="paymentRef" :info="detailInfo" @getDetail="getDetail(false)" @changePayLoading="changePayLoading" :paymentInfo="paymentInfo" :platform="platform" @paySucc="paySucc"></payment>
    <!-- 不可用原因弹窗 -->
    <unavailabilityDialog ref="unavailabilityRef" @changeApply="changeApply" :orderID="orderID" :platform="platform" :detailInfo="detailInfo" @getDetail="getDetail(false)"></unavailabilityDialog>
  </div>
</template>

<script setup>
import {
  XlCard,
  XlIcon,
  XlImage,
  XlMessage,
  XlMessageBox,
  XlTabs,
  XlTooltip,
  XlButton,
  XlCheckbox,
  XlLoading
} from "@shining3d/ui-components";
import { ref, onMounted, computed, nextTick, defineEmits } from 'vue';
import { useRouter } from 'vue-router';
import TitleName from '../../components/titleName.vue';
import ThreeDModel from '../../components/threeDModel.vue';
import creditCardApi from "../../api/creditCard";
import designAdjustment from "./components/designAdjustment.vue";
import designAdjustmentAdmin from "./components/designAdjustmentAdmin.vue";

import unavailabilityDialog from './components/unavailabilityDialog.vue'
import image from '../../assets/image/one.png';
// import Api from '../../api/orderDetail/index.js';
import orderApi from '../../api/order';
import _get from 'lodash/get';
import { $getCdnUrl } from '../../utils/common.js';
import { User } from "@shining3d/icons-vue";
import router from '@/router';
import { transModelList } from '../../utils/common.js';
import noData from '../../components/no-data.vue'
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { useStore } from "vuex";
import dropIn from './components/dropIn.vue';
import payment from './components/payment.vue';
import { VueCookieNext } from 'vue-cookie-next';
import { createElement, loadAirwallex } from 'airwallex-payment-elements';
import Bus from '../../utils/bus.js';
import { $getLocalStorage } from '@shining3d/common-module/utils/index.js';
import { orderDetail } from '../../api/orderDetail/index.js';
import aiFailSvg from '../../assets/image/aiFail.svg';
import aiTransferSvg from '../../assets/image/aiTransfer.svg';

const route = router.currentRoute.value;
const $store = useStore();
const { $t } = useLang("@shining3d/xl-design-order");
const lang = ref(VueCookieNext.getCookie("lang"));

const props = defineProps({ 
  platform: { // 有值为设计服务后台
    type: String,
    default: ''
  }
})

const emits = defineEmits(['paySucc']);

console.log(props.platform, 'platformplatformplatform' );
const Api = orderDetail[props.platform || 'dental']

// 设计调整弹窗服务平台
const designAdjustmentAdminRef = ref()
// 设计调整服务平台
const handleDesignAdjustmentAdmin = () => {
  designAdjustmentAdminRef.value.show();
}
const onSubmitAdmin = () => {
  XlMessageBox({
    title: $t('design.orderDetail.acceptDesignLoading') || '确定设计',
    message: $t( 'design.orderDetail.determineDesign' ),
    cancelButtonText: $t( 'design.cancel' ),
    confirmButtonText: $t( 'design.confirm' )
}).then(() => {
  orderApi.dentalxConfirmTransferOrderDesign({
    id: detailInfo.value?.id || route?.params?.id,
  }).then((res) => {
    changePayLoading( false );
    if( res && res.status === 'success' ){
      XlMessage({ type: 'success', message: $t('design.orderDetail.acceptSuccess') || '确定设计完成' });
      Bus.$emit( 'updateOrderList' );
      router.push({ name: 'Design', params: { forceUpdate: true }});
    }
  })
  });
};

const statementCheck = ref( false );
const previewModel = ref( null );

const srcList = ref([]);
const dropInRef = ref();
const payLoading = ref( false ); 
// 修改确定设计按钮状态
const changePayLoading = (val) => {
  payLoading.value = val;
}

const paymentRef = ref( null );
// 机构id
const institutionId = computed(() => {
  let id = _get( $store, 'state.factorySelect.id', '' );
  if ( props.platform === 'designerService' ) {
    id = _get( $store, 'state.factoryID', '' )
  }
  return id;
});
const paymentInfo = ref()
// 确认验收 or 设计师应用AI结果
const onSubmit = () => {
  if ( !statementCheck.value ) {
    XlMessage({ type: 'warning', message: $t('design.orderDetail.acceptanceCheckTip') || '请先勾选免责申明，再确认验收' });
    return;
  } else {
    changePayLoading( true );
    // 设计次数>0：已经支付过的售后订单，直接变更订单状态，不需要再次付款
    if(detailInfo.value.designTimes){
      orderApi.changeCloudOrderState({
        orderID: route?.params?.id,
        orgID: institutionId.value,
        action: 'toComplete'
      }).then((res) => {
        changePayLoading( false );
        if( res && res.status === 'success' ){
          XlMessage({ type: 'success', message: $t('design.orderDetail.acceptSuccess') || '确定设计完成' });
          Bus.$emit( 'updateOrderList' );
          //跳转到数据下载
          router.push({name: 'orderDetail', params: { id: route?.params?.id }, query: { type: 'dataDownload' }});
        }
      })
    // 设计次数为0：未支付过的订单
    } else {
      orderApi.createShiningPay({
        sourcePlatform: props.platform === 'designerService' ? 'dentalxDesign' : 'dentalCloud',
        returnUrl: window.location.href,
        orderID: route?.params?.id
      }).then((res) => {
        if( res && res.status === 'success' ){
          paymentInfo.value = res.result;
          const airwallexData = {
            intentIdData: res.result?.airwallex?.paymentIntentID,
            clientSecretData: res.result?.airwallex?.clientSecret,
            currencyData: res.result?.airwallex?.currency,
            envData: res.result?.airwallex?.env,
            payStatus: res.result?.airwallex?.payStatus
          }
          paymentRef.value.show(airwallexData);
        } else {
          changePayLoading( false );
        }
      })

      // creditCardApi.payWithCard({
      //   returnUrl: window.location.href,
      //   orderID: detailInfo.value?.id || route?.params?.id,
      //   platform: window.app?.entryName || 'dental',
      //   businessID: institutionId,
      // }).then((res) => {
      //   if( res && res.status === 'success' && res.result){
      //     if(res.result.payStatus ==='SUCCEEDED'){
      //       changePayLoading( false );
      //       XlMessage({ type: 'success', message: $t('design.orderDetail.acceptSuccess') || '确定设计完成' });
      //       getDetail();
      //       //跳转到数据下载
      //       router.push({name: 'orderDetail', params: { id: route?.params?.id }, query: { type: 'dataDownload' }});
      //     } else {
      //       paymentRef.value.show(res.result?.paymentIntentID, res.result?.clientSecret, res.result?.currency, res.result?.env);
      //     }
      //   } else {
      //     changePayLoading( false );
      //   }
      // })

    }
  }
};

const gotoback = () => {
  // todo: 返回订单列表页面
  if ( props.platform ) {
    router.go( -1 );
  } else {
    router.push({name: 'designOrder'})
  }
};
const imageUrl = ref('');
// 设计调整弹窗
const designAdjustmentRef = ref()
// 设计调整
const handleDesignAdjustment = () => {
  designAdjustmentRef.value.show();
}

const detailInfo = ref({});
const orderID = computed(() => _get( route, 'params.id', '' ));
const loading = ref(true);

// 是否应用设计结果
const isApplyModel = ref();
const changeApply = (value) => {
  isApplyModel.value = value;
}
const unavailabilityRef = ref()
// 设计结果不可用
const handleUnavailable = () => {
  unavailabilityRef.value?.show();
}

// ai 设计不可用
const onAdjustmentDesigner = () => {
  unavailabilityRef.value?.show();
};

const paySucc = () => {
  // todo: 设计师弹出上传设计结果文件，需要设计结果数据
  emits('paySucc', detailInfo.value);
};

const refLoading = ref()
const containerRef = ref()
// 组织切换接口调取
const handleOrganizationChange = async ( val ) => {
	if ( val.id ) {
		if ( !await $store.dispatch( 'routerBeforeReload' )) {
			return false;
		}
		const res = await orderApi.postOrgChange({ orgID: val.id });
		// 详情 页面要跳转到列表
		if ( res && res.status === 'success' ) {
			// 清除节点提示
			localStorage.removeItem( 'clonseNodeTip' );
			sessionStorage.setItem( 'lastOrganization', $getLocalStorage( 'currentOrganization' )?.id ?? '' );
			$store.commit( 'setFactorySelect', val );
      window.location.reload();
		} else {
      refLoading.value?.close();
    }
		return true;
	} else {
    refLoading.value?.close();
  }
	return false;
};
const toothNumCheck = (data) => {
  // 有符合规则的牙号就强制变更为上下颚
  // FDI牙号，考虑乳牙牙号
  if ( data.toothNum) {
    if( (data.toothNum > 30 && data.toothNum < 60) || data.toothNum > 70 ) { 
      data.detailType = 'lowerJaw';
    } else {
      data.detailType = 'upperJaw';
    }
  }
  return data
}

// ai 文件生成失败/生成中：仅在ai订单中展示 点击查看AI设计文件时展示
const aiFail = computed(() => {
  let status = '';
  if ( detailInfo.value?.aiOrder === 1 && route?.query?.type == 'ai') {
    if ( !detailInfo.value.aiDesignAttachs?.length ) {
      status = 'transfer'; // 转换中
    } else if ( detailInfo.value.aiDesignAttachs?.some(item => item.previewStatus === 'failed')) {
      status = 'failed';
    }
  }
  return status;
});

const showAiResult = ref( false );
const showManualResult = ref( false );

const aiFiles = ref([]);
const manualFiles = ref([]);
const getDetail = ( needLoading = true ) => {
  const params = {
    orgID: institutionId.value,
    orderID: orderID.value,
    lang: VueCookieNext.getCookie('lang')
  }
  // 在设计师平台存在订单支付成功后停留在ai单重新获取更新详情，这时候不需要loading状态
  if ( needLoading  ) {
    loading.value = true;
  }
  let type = 'order';
  // 设计师查看ai订单进行验收的话 是另一个获取详情接口
  if ( props.platform === 'designerService' && route?.query?.type == 'ai' ) {
    type = 'aiOrder';
  }
  Api.designOrderInfo( params, type ).then( res => {
    if ( res && res.status === 'success' ) {
      if( res.result?.orgID && institutionId.value !== res.result?.orgID ){
        const factoryInfo = $store.state.factoryObjs?.find((item) => item.id === res.result.orgID )
        if( factoryInfo ){
          refLoading.value = XlLoading.service({
            target: containerRef.value,
            background: 'rgba(255,255,255,1)',
          });
          handleOrganizationChange(factoryInfo)
        }
			  // Bus.$emit( 'handleOrganizationChange', {id: res.result.orgID} );
      }
      detailInfo.value = res.result || {};
      imageUrl.value = res.result?.orderImage ? $getCdnUrl(res.result?.orderImage) : '';
      srcList.value = res.result?.qualityFiles?.map((item) => ({
        url: $getCdnUrl({bucket: item?.bucket, dfsID: item?.dfsID}),
        filename: item?.fileName
      }))

      

      nextTick(() => {
        // 设计结果文件
        manualFiles.value = transModelList(res.result?.designAttachs || []).map(item=> {
          item.resultType = 'manual';
          item.attachTip =  $t('design.designResult.file') || '设计结果'
          item.feModelFileType = 'designResult'
          if (props.platform) {
            item = toothNumCheck(item)
          }
          return item
        })
        // 原始文件
        const originFiles = transModelList(res.result?.attachs || []).map(item=> {
          item.resultType = 'origin';
          return item
        }); 

        // if(res.result?.aiDesignAttachs.length) {
        //   res.result.aiDesignAttachs.push(JSON.parse(JSON.stringify(res.result?.aiDesignAttachs[0])))
        //   res.result.aiDesignAttachs.push(JSON.parse(JSON.stringify(res.result?.aiDesignAttachs[0])))
        //   res.result.aiDesignAttachs[1].toothNum = 32
        //   res.result.aiDesignAttachs[0].toothNum = 33
        //   res.result.aiDesignAttachs[2].toothNum = 11
        // }
         aiFiles.value = transModelList(res.result?.aiDesignAttachs || []).map(item=> {
          item.resultType = 'ai';
          item = toothNumCheck(item);
          switch (item.detailType) {
            case 'upperJaw':
              item.attachTip = $t('design.toothUpperJaw')
              break;
             case 'lowerJaw':
              item.attachTip = $t('design.toothLowerJaw')
              break;
            default:
              item.attachTip = $t('design.designResult.file')
              break;
          }
          return item
        });

        if ( !props.platform ) {
          // 默认齿科云平台
          showAiResult.value = detailInfo.value.aiOrder;
          showManualResult.value = !detailInfo.value.aiOrder;
        } else if ( props.platform === 'designerService' && route?.query?.type == 'ai') {
          showAiResult.value = true;
          showManualResult.value = false;
        } else {
          showAiResult.value = !!aiFiles.value.length;
          showManualResult.value = !!manualFiles.value.length;
        }
        
        // const files = props.platform ? [...manualFiles.value, ...originFiles, ...aiFiles.value] : [...manualFiles.value, ...originFiles];
        const files = [...manualFiles.value, ...originFiles, ...aiFiles.value];
        
        previewModel.value?.setData( files, {}, [], res.result?.designDataPreviewStaus );
        loading.value = false;
      });
    }
  }).catch(() => {
    loading.value = false
  })
};
// const res = {
//     "status": "success",
//     "result": {
//         "bustPayWay": 'debitCard',
//         "giftCard": {
//             "total": 1000,
//             // 'list': null
//             "list": [
//                 {
//                     "pointCardID": "1",
//                     "point": 0,
//                     "totalPoint": 500,
//                     "cardNo": "111122222049210238910411",
//                     "expiredOn": "2024-10-01 00:00:00",
//                     "choose": true
//                 },
//                 {
//                     "pointCardID": "2",
//                     "point": 0,
//                     "totalPoint": 500,
//                     "cardNo": "111122222049210238910412",
//                     "expiredOn": "2024-10-02 00:00:00",
//                     "choose": false
//                 }
//             ]
//         },
//         "debitCard": {
//             "total": 1000,
//             "list": [
//                 {
//                     "pointCardID": "1",
//                     "point": 200,
//                     "totalPoint": 1000,
//                     "cardNo": "111122222049210238910413",
//                     "expiredOn": "2024-10-03 00:00:00",
//                     "choose": false
//                 },
//                 {
//                     "pointCardID": "3",
//                     "point": 200,
//                     "totalPoint": 1000,
//                     "cardNo": "111122222049210238910413",
//                     "expiredOn": "2024-10-03 00:00:00",
//                     "choose": false
//                 },
//                 {
//                     "pointCardID": "4",
//                     "point": 200,
//                     "totalPoint": 1000,
//                     "cardNo": "111122222049210238910413",
//                     "expiredOn": "2024-10-03 00:00:00",
//                     "choose": false
//                 },
//                 {
//                     "pointCardID": "2",
//                     "point": 100,
//                     "totalPoint": 1000,
//                     "cardNo": "111122222049210238910414",
//                     "expiredOn": "2024-10-04 00:00:00",
//                     "choose": true
//                 }
//             ]
//         },
//         "airwallex": {
//             "PaymentIntentID": "xxxxxxxx",
//             "clientSecret": "xxxxxxxxx",
//             "payStatus": "REQUIRES_PAYMENT_METHOD",
//             "nextAction": {
//                 "type": "redirect_iframe",
//                 "method": "GET",
//                 "url": "https://pci-api-demo.airwallex.com/pa/card3ds/hk/three-ds- method/redirect/start?key=67e59071-a72a-447f-a80f-841e28965615",
//                 "stage": "WAITING_DEVICE_DATA_COLLECTION"
//             }
//         }
//     }
// }
onMounted(() => {
  getDetail();
  // paymentInfo.value = res.result
});

</script>
<script>
export default {
	name: 'designAccept'
}
</script>
<style lang="scss" scoped>
.design-accept-wrap {
  padding: 17px 16px 14px 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .case-card-style {
    margin-bottom: 16px;
    --el-card-border-radius: 6px;
    height: 78px;
    min-height: 78px;
    box-sizing: border-box;
  }
  .case-top-icon {
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 0;
    flex-shrink: 0;
    &.designType {
      background-color: $color-n2;
      border-radius: 6px;
    }
    &.back-icon {
      margin-left: -5px;
      margin-right: 7px;
    }
  }
  .case-top-conts {
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
  }
  .case-top-conts-t {
    @include h3();
    line-height: 26px;
    color: $color-n10;
    @include font-family85();
    margin-bottom: 4px;
  }
  .case-top-conts-b {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &-span {
      @include h5();
      font-family: $font-family;
      color: $color-n7;
    }
    &-box {
      display: flex;
      align-items: center;
      margin-right: 16px;
    }
    .icon {
      margin-right: 4px;
    }
  }
  .design-card-content {
    width: 100%;
    height: 100%;
    :deep(.el-card__body) {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 100%;
      height: 100%;
    }
    .content {
      flex: 1;
      display: flex;
      height: calc(100% - 68px);
      .left {
        flex: 1;
        position: relative;
        .is-apply-icon{
          position: absolute;
          bottom: 50px;
          right: 50px;
          z-index: 99;
          img{
            width: 172px;
            height: 172px;
          }
        }
        .ai-fail-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 10%;
          width: 100%;
          height: 100%;

          p {
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;
            text-align: center;
            color: rgba(150, 151, 153, 1);
            margin-top: 6px;
          }
        }
      }
      .right {
        width: 248px;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-left: 1px solid #E0E4EA;
        padding: 16px 13px 16px 16px;
        display: flex;
        flex-direction: column;

        .image-wrap {
          flex: 1;
          height: 100%;
          overflow-y: auto;

          .item {
            // text-align: center;
            width: 100%;
            overflow: hidden;
            margin-bottom: 16px;
            &:last-child{
              margin-bottom: 0 !important;
            }
            :deep(.xl-image) {
              height: 121px;
              min-width: 218px;
              border-radius: 6px;
              box-sizing: border-box;
              border: 1px solid #E0E4EA;
            }
            .title {
              width: 100%;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              line-height: 18px;
              text-align: left;
              font-size: 12px;
              color: #737E99;
            }

            &:hover {
              .title {
                color: #5587FF;
              }
              :deep(.xl-image) {
                border-color: #5587FF;
              }
            }
          }
        }
        :deep(.el-image-viewer__canvas) {
          img {
            min-width: 800px;
          }
        }
      }
    }

    .footer {
      height: 68px;
      padding-left: 16px;
      padding-right: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #E0E4EA;
      box-sizing: border-box;

      .statement {
        display: flex;
        align-items: center;
        color: #42526E;
        font-size: 14px;
        margin-right: 90px;
        :deep(.xl-checkbox) {
          margin-right: 8px;
        }
        :deep(.el-checkbox__inner) {
          width: 16px;
          height: 16px;
        }
      }
      .btns {
        display: flex;
        :deep(.xl-button span) {
          white-space: nowrap;
        }
      }
    }
  }
  .order-title {
        display: flex;
        align-items: center;
        .info-box {
          display: flex;
          align-items: center;
        }
        .user-icon{
          margin-left: 24px;
        }
        .info-text {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          margin-left: 4px;
          color: #737e99;
          .text-color {
            color: #42526e;
          }
        }
        .xl-icon {
          margin-left: 24px;
        }
        .case-text {
          font-size: 18px;
          font-weight: 700;
          line-height: 26px;
          margin-right: 8px;
          color: #2c364e;
        }
        .order-status {
          height: 18px;
          padding: 1px 6px 1px 6px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
        }
        .blue-color{
          background: #edf3ff;
          color: #5587ff;
        }
        .red-color{
          background: #FDEEEE;
          color: #E64C4C;
        }
        .green-color{
          background: #E7F9F3;
          color: #0FBD81;
        }
        .gray-color{
          background: #EFF1F7;
          color: #42526E;
        }
      }
      .order-img {
        // margin: 0 16px 0 24px;
        height: 54px;
        box-sizing: border-box;
        width: 81px;
        border: 1px solid #E0E4EA;
        border-radius: 2px;
      }
      .no-data-box {
          height: 100%;
      }
      :deep(.xl-dialog.el-dialog){
        min-width: 700px;
        .el-dialog__body{
          max-height: calc(100vh - 78px);
        }
      }
}
</style>